// load packages into the global scope

import Cookies from "js-cookie";
import jQuery from "jquery";

window.$ = window.jQuery = jQuery;
window.Cookies = Cookies;
